import React from "react";
import styled from "styled-components";
import privacylogo from "../../../src/Assests/svg/Trackright-privary-logo.svg";
import { Col, Row } from "antd";

const PolicyContainer = styled.div`
  font-family:
    -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial,
    sans-serif;

  padding: 20px;
  color: #333333;
  line-height: 1.6;
`;

const Banner = styled.div`
  background: linear-gradient(135deg, #1e7e34, #28a745);
  border-radius: 12px;
  padding: 40px 20px;
  text-align: center;
  margin-bottom: 40px;
  position: relative;
  overflow: hidden;

  &::before,
  &::after {
    content: "";
    position: absolute;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 50%;
  }
  &::before {
    width: 60px;
    height: 60px;
    top: 20px;
    left: 20px;
  }
  &::after {
    width: 100px;
    height: 100px;
    bottom: -20px;
    right: 20px;
  }
`;

const MainTitle = styled.h1`
  color: #ffffff;
  font-size: 32px;
  font-weight: 600;
  margin: 0;
  letter-spacing: 0.5px;
`;

const SectionHeading = styled.h2`
  font-size: 20px;
  font-weight: 700;
  color: #2c3e50;
  margin-top: 30px;
  margin-bottom: 15px;
`;

const Paragraph = styled.p`
  font-size: 20px;
  font-weight: 500;
  color: #636980;
  margin-bottom: 20px;
`;

const List = styled.ul`
  margin-bottom: 25px;
  padding-left: 20px;
`;

const ListItem = styled.li`
  font-size: 19px;
  font-weight: 500;
  color: #636980;
  margin-bottom: 10px;
  font-family: DM Sans strong {
    font-weight: 400;
    color: #636980;
    font-size: 17px;
  }
`;

const PrivacyPolicycontainer = () => {
  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "30px",
        }}
      >
        <img style={{ width: "" }} src={privacylogo} alt="privacylogo" />
      </div>
      <Row>
        <Col xl={4}></Col>
        <Col xl={16}>
          <PolicyContainer>
            <Paragraph>
              TrackRight (“we,” “us,” or “our”) is committed to protecting the
              privacy and personal data of our users (“you” or “your”). This
              Privacy Policy explains the types of information we collect, how
              we use it, the rights you have over your data, and the safeguards
              we apply to protect it.
            </Paragraph>

            <Paragraph>
              This Privacy Policy applies to our mobile application (“App”),
              TrackRight, available on the Google Play Store, and to our related
              services, including TrackRight AI, AI+ and AI Cargo.
            </Paragraph>

            <SectionHeading>1. Information We Collect</SectionHeading>
            <Paragraph>
              We may collect the following types of information:
            </Paragraph>
            <List>
              <ListItem>
                <strong>User Information:</strong> Name, email address, company
                name, and related contact details.
              </ListItem>
              <ListItem>
                <strong>Vehicle Data:</strong> Vehicle Identification Number
                (VIN), license plate number, make, model, and year.
              </ListItem>
              <ListItem>
                <strong>Driver Data:</strong> Name, driver’s license number, and
                contact information. (with client consent)
              </ListItem>
              <ListItem>
                <strong>Location Data:</strong> Real-time GPS location of
                vehicles (with consent).
              </ListItem>
              <ListItem>
                <strong>Customer Data:</strong> Customer names and contact
                details (if entered into the App).
              </ListItem>
            </List>

            <SectionHeading>2. How We Use Your Information</SectionHeading>
            <Paragraph>
              We process collected data for the following purposes:
            </Paragraph>
            <List>
              <ListItem>
                To provide and improve the App and its functionalities.
              </ListItem>
              <ListItem>
                To track vehicles, optimize deliveries, and enhance operational
                efficiency.
              </ListItem>
              <ListItem>
                To generate and deliver periodic reports to clients.
              </ListItem>
              <ListItem>
                To communicate with you regarding product updates, promotions,
                and customer support.
              </ListItem>
              <ListItem>
                To carry out marketing activities related to TrackRight (with
                consent).
              </ListItem>
              <ListItem>
                To integrate with third-party services, such as telematics
                providers, ERP software for TrackRight AI and AI Cargo.
              </ListItem>
              <ListItem>
                To comply with legal obligations and enforce contractual
                agreements.
              </ListItem>
            </List>

            <SectionHeading>3. Legal Basis for Processing</SectionHeading>
            <Paragraph>
              We process your data based on the following legal grounds:
            </Paragraph>
            <List>
              <ListItem>
                <strong>Contractual necessity:</strong> to provide services
                under the client contract.
              </ListItem>
              <ListItem>
                <strong>Consent:</strong> for location data collection and
                marketing communications.
              </ListItem>
              <ListItem>
                <strong>Legitimate interests:</strong> to improve our services
                and ensure operational security.
              </ListItem>
              <ListItem>
                <strong>Legal compliance:</strong> where required by law.
              </ListItem>
            </List>

            <SectionHeading>4. Sharing Your Information</SectionHeading>
            <Paragraph>
              We will not share your personal data with third parties except in
              the following cases:
            </Paragraph>
            <List>
              <ListItem>
                <strong>Service Providers:</strong> We use trusted partners such
                as Amazon Web Services (AWS) for data hosting, ERP software for
                consignments, and telematics providers for telematics
                integration. These providers are contractually bound to protect
                your data.
              </ListItem>
              <ListItem>
                <strong>Legal Obligations:</strong> We may disclose information
                if required by law or necessary to protect the rights, safety,
                or property of TrackRight, our users, or the public.
              </ListItem>
            </List>
          </PolicyContainer>
        </Col>
        <Col xl={4}></Col>
      </Row>
    </>
  );
};

export default PrivacyPolicycontainer;
